import { FC } from "react";
import { deprecatedTones } from "@src/deprecatedDesignSystem/styles/deprecatedColors";
import AnimatedBanner from "@src/components/libraryItemDetailPages/course/AnimatedBanner";
import { useAtomValue } from "jotai";
import { firstSyncErrorAtAtom } from "@src/hooks/useSyncBuilderActionsToServer";

const BuilderActionSyncingErrorBanner: FC = () => {
  const firstSyncErrorAt = useAtomValue(firstSyncErrorAtAtom);
  return (
    <AnimatedBanner
      showBanner={!!firstSyncErrorAt}
      iconType={"wifi-no-connection"}
      text={
        "Encountered unexpected error syncing updates to server. Please refresh if this continues."
      }
      backgroundColor={deprecatedTones.red4}
      color={deprecatedTones.red10}
      borderRadius={0}
    />
  );
};

export default BuilderActionSyncingErrorBanner;
